import React, { useMemo } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  SearchFacets,
  SearchFacetRefinementSelect,
  SearchFacetRefinementCheckboxes,
} from '@uncinc/react-searchkit';
import type { SearchFacetsProps } from '@uncinc/react-searchkit/dist/components/Facets';

import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { SCREEN_LG } from '../../../config/constants';
import { facetAttributes } from '../config';
import FacetsDialog from './Dialog';

import './style.scss';

const SEARCH_ALL_CONTENT_FACET_REFINEMENT_CHECKBOXES_LIMIT = 5;

const Facets: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      {facetAttributes.map((facetAttribute) => {
        const attribute = typeof facetAttribute === 'object' ? facetAttribute.attribute : facetAttribute;
        const Facet = attribute === 'content_type' ? SearchFacetRefinementCheckboxes : SearchFacetRefinementSelect;

        return (
          <Facet
            className="Select__inner"
            key={attribute}
            title={t(`searchkit.facets.${attribute}.label`)}
            placeholder={t(`searchkit.facets.${attribute}.placeholder`)}
            attribute={attribute}
            limit={attribute === 'content_type' ? SEARCH_ALL_CONTENT_FACET_REFINEMENT_CHECKBOXES_LIMIT : undefined}
            showMore
            transformItems={(items) => items.map((item) => ({
              ...item,
              label: attribute === 'content_type' ? t(`content_types.${item.value}.type`) : item.label,
            }))}
          />
        );
      })}
    </>
  );
};

interface SearchAllContentFacetsProps extends SearchFacetsProps {
  dialogEnabled?: boolean;
}

// These facets are also used in the MetaSearch
const SearchAllContentFacets: React.FC<SearchAllContentFacetsProps> = (props) => {
  const {
    dialogEnabled = true,
    className,
    ...restProps
  } = props;

  const { width } = useWindowDimensions();
  const renderAsDialog = useMemo(() => width < SCREEN_LG, [width]);

  const classNames = c('SearchAllContent__Facets', className);

  return (
    <SearchFacets {...restProps} className={classNames}>
      {renderAsDialog && dialogEnabled ? (
        <FacetsDialog>
          <Facets />
        </FacetsDialog>
      ) : (
        <Facets />
      )}
    </SearchFacets>
  );
};

export default SearchAllContentFacets;
